import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import * as ApplicationStandaloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import { useApplicationStandaloneStoreGetters, useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { APPLICATION_VISIBILITY_TOGGLES } from "@Client/@Utils/application/visibility-toggles";
import { computed, watch } from "@vue/composition-api";
import { isNumber, some } from "lodash";
export const useApplicationFieldVisibility = () => {
  const {
    SET_CURRENT_COMPUTED_SCHEMA_BY_PATH
  } = useApplicationStandaloneStoreMutations([ApplicationStandaloneMutations.SET_CURRENT_COMPUTED_SCHEMA_BY_PATH]);
  const {
    GET_CURRENT_SCHEMA,
    GET_FIELD_BY_PATH
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_CURRENT_SCHEMA, ApplicationStandaloneGetters.GET_FIELD_BY_PATH]);
  const currentFlow = computed(() => {
    return GET_FIELD_BY_PATH.value("flow");
  });
  const computeSchemaVisibility = pathFromSchema => {
    return computed(() => {
      try {
        var _GET_CURRENT_SCHEMA$v, _GET_CURRENT_SCHEMA$v2;
        return (_GET_CURRENT_SCHEMA$v = GET_CURRENT_SCHEMA.value) == null ? void 0 : (_GET_CURRENT_SCHEMA$v2 = _GET_CURRENT_SCHEMA$v[pathFromSchema]) == null ? void 0 : _GET_CURRENT_SCHEMA$v2.visible[currentFlow.value];
      } catch (error) {
        console.warn(`"${pathFromSchema}" path not found in schema`);
        console.error(error);
        return false;
      }
    });
  };
  const computeTogglerVisibility = (path, dependsUponPaths) => {
    const togler = computed(() => {
      var _APPLICATION_VISIBILI, _APPLICATION_VISIBILI2;
      const dependsUponBindings = _mapInstanceProperty(dependsUponPaths).call(dependsUponPaths, path => computed(() => {
        return GET_FIELD_BY_PATH.value(path);
      }));
      const pathWithoutIndexes = _replaceAllInstanceProperty(path).call(path, /\[[[0-9]+\]/g, "");
      const dependencies = (_APPLICATION_VISIBILI = APPLICATION_VISIBILITY_TOGGLES == null ? void 0 : (_APPLICATION_VISIBILI2 = APPLICATION_VISIBILITY_TOGGLES[pathWithoutIndexes]) == null ? void 0 : _APPLICATION_VISIBILI2.isVisibleWhen) != null ? _APPLICATION_VISIBILI : {};
      const visible = some(dependencies, dependency => {
        var _dependency$hasValues;
        const hasValues = (_dependency$hasValues = dependency.hasValues) == null ? void 0 : _dependency$hasValues.some(value => dependsUponBindings.some(binding => binding.value === value));
        const moreThan = isNumber(dependency.moreThan) && dependsUponBindings.some(binding => {
          var _binding$value;
          return (((_binding$value = binding.value) == null ? void 0 : _binding$value.length) || binding.value) > dependency.moreThan;
        });
        const lessThan = isNumber(dependency.lessThan) && dependsUponBindings.some(binding => {
          var _binding$value2;
          return (((_binding$value2 = binding.value) == null ? void 0 : _binding$value2.length) || binding.value) < dependency.lessThan;
        });
        return hasValues || moreThan || lessThan;
      });
      return visible;
    });
    watch(togler, visible => {
      SET_CURRENT_COMPUTED_SCHEMA_BY_PATH({
        path,
        visible
      });
    }, {
      immediate: true
    });
    return togler;
  };
  return {
    computeSchemaVisibility,
    computeTogglerVisibility
  };
};